import { Link } from "react-router-dom";

export default function AGB() {
  return (
    <div className="max-w-3xl mx-auto px-4 md:px-8 py-16 md:py-20" data-testid="agb-page">
      <div className="text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-4">
        <span className="divider-thin" />Rechtliches
      </div>
      <h1 className="font-heading font-bold text-3xl md:text-5xl tracking-tight text-slate-900 mb-3 leading-[1.05]">
        Allgemeine <span className="font-serif italic font-medium">Geschäftsbedingungen</span>
      </h1>
      <p className="text-sm text-slate-500 mb-12">
        Stand: Juni 2026 · D.R Automobile, Ringgasse 6, 4840 Vöcklabruck
      </p>

      <div className="bg-amber-50 border-l-4 border-amber-400 p-5 mb-10 text-xs text-amber-900">
        <strong>Wichtig:</strong> Diese AGB sind eine sorgfältig erstellte Vorlage, ersetzen aber keine
        anwaltliche Beratung. Bitte vor Veröffentlichung von der WKO Oberösterreich (Fachgruppe
        Fahrzeughandel) oder einem Rechtsanwalt prüfen lassen.
      </div>

      <div className="space-y-10 text-sm text-slate-700 leading-relaxed">
        <Section title="§ 1 Geltungsbereich und Begriffsbestimmungen">
          <p>
            (1) Diese Allgemeinen Geschäftsbedingungen (im Folgenden „AGB") gelten für sämtliche
            Geschäftsbeziehungen zwischen <strong>D.R Automobile</strong>, Inhaber D. R., Ringgasse 6,
            4840 Vöcklabruck, Österreich (im Folgenden „Verkäufer") und dem Käufer über den Verkauf
            gebrauchter Kraftfahrzeuge.
          </p>
          <p>
            (2) <em>Verbraucher</em> im Sinne dieser AGB ist jede natürliche Person, die ein Rechtsgeschäft
            zu Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbständigen
            beruflichen Tätigkeit zugerechnet werden können (§ 1 KSchG). <em>Unternehmer</em> ist, wer das Geschäft
            im Rahmen seines Unternehmens tätigt (§ 1 UGB).
          </p>
          <p>
            (3) Abweichende, entgegenstehende oder ergänzende AGB des Käufers werden nicht Vertragsbestandteil,
            es sei denn, der Verkäufer hat ihrer Geltung ausdrücklich und schriftlich zugestimmt.
          </p>
        </Section>

        <Section title="§ 2 Vertragsabschluss">
          <p>
            (1) Die Darstellung der Fahrzeuge auf der Website www.dr-automobile.at sowie in Inseraten stellt
            kein bindendes Angebot des Verkäufers dar, sondern eine unverbindliche Aufforderung an den Käufer,
            seinerseits ein Angebot abzugeben (<em>invitatio ad offerendum</em>).
          </p>
          <p>
            (2) Mit Absenden einer Anfrage über das Online-Formular, per E-Mail oder Telefon gibt der Käufer
            eine unverbindliche Interessensbekundung ab. Der Kaufvertrag kommt durch Unterzeichnung des
            schriftlichen Kaufvertrags bzw. der Auftragsbestätigung oder durch tatsächliche Übergabe des
            Fahrzeugs gegen Zahlung zustande.
          </p>
          <p>
            (3) Vorbehalt: Solange der Vertrag nicht schriftlich abgeschlossen ist, behält sich der Verkäufer
            den Zwischenverkauf an Dritte ausdrücklich vor.
          </p>
        </Section>

        <Section title="§ 3 Preise, Zahlung und Verzug">
          <p>
            (1) Alle Preise verstehen sich in Euro inklusive der jeweils geltenden Umsatzsteuer.
          </p>
          <p>
            (2) Soweit nicht anders ausgewiesen, erfolgt der Verkauf der Gebrauchtfahrzeuge
            <strong> differenzbesteuert gemäß § 24 UStG</strong>. Ein gesonderter Ausweis der Umsatzsteuer
            sowie ein Vorsteuerabzug sind in diesem Fall nicht möglich.
          </p>
          <p>
            (3) Der Kaufpreis ist — soweit nicht anders schriftlich vereinbart — bei Übergabe des Fahrzeugs
            zur Zahlung fällig, und zwar wahlweise:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>per Banküberweisung mit Zahlungseingang vor Übergabe, oder</li>
            <li>in bar bis maximal € 10.000,– (gemäß Geldwäschegesetz, Identitätsfeststellung erforderlich), oder</li>
            <li>per Bankbestätigung (zertifizierter Bankscheck oder vorab überwiesener Betrag).</li>
          </ul>
          <p>
            (4) Anzahlungen werden, sofern vereinbart, schriftlich bestätigt. Sie sind im Falle eines vom Käufer
            zu vertretenden Vertragsrücktritts bis zur Höhe des nachgewiesenen Verkäuferschadens (insb. Aufwandsersatz,
            Wertminderung, Mehrkosten Wiederverkauf) als pauschalierter Schadenersatz einbehaltbar (vgl. § 909 ABGB).
          </p>
          <p>
            (5) Bei Zahlungsverzug ist der Verkäufer berechtigt, gesetzliche Verzugszinsen zu verrechnen
            (Verbraucher: 4 % p. a. gem. § 1000 Abs. 1 ABGB; Unternehmer: 9,2 Prozentpunkte über dem Basiszinssatz
            gem. § 456 UGB) sowie alle zur zweckentsprechenden Rechtsverfolgung notwendigen Mahn- und Inkassokosten.
          </p>
        </Section>

        <Section title="§ 4 Übergabe, Gefahrübergang und Eigentumsvorbehalt">
          <p>
            (1) Die Übergabe des Fahrzeugs erfolgt am Geschäftssitz des Verkäufers in 4840 Vöcklabruck, sofern
            nichts anderes schriftlich vereinbart wurde.
          </p>
          <p>
            (2) Die Gefahr geht mit Übergabe des Fahrzeugs auf den Käufer über.
          </p>
          <p>
            (3) Bis zur vollständigen Bezahlung des Kaufpreises sowie sämtlicher Nebenkosten bleibt das
            Fahrzeug Eigentum des Verkäufers (<strong>Eigentumsvorbehalt gemäß §§ 1063, 1063a ABGB</strong>).
            Eine Weiterveräußerung, Verpfändung oder Sicherungsübereignung durch den Käufer vor vollständiger
            Bezahlung ist unzulässig.
          </p>
        </Section>

        <Section title="§ 5 Gewährleistung">
          <p>
            (1) Es gelten die gesetzlichen Gewährleistungsbestimmungen (§§ 922 ff. ABGB) sowie ggf. das
            Verbrauchergewährleistungsgesetz (VGG) für Verbrauchergeschäfte.
          </p>
          <p>
            (2) Die Gewährleistungsfrist für gebrauchte Kraftfahrzeuge beträgt:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li><strong>Verbraucher</strong>: 2 Jahre ab Übergabe (gesetzlich, § 10 VGG). Eine Verkürzung auf 1 Jahr ist gemäß § 9 VGG mit gesondertem schriftlichen Hinweis und freier Verhandlung möglich.</li>
            <li><strong>Unternehmer</strong>: nach individueller Vereinbarung; bei Fehlen einer solchen 6 Monate ab Übergabe.</li>
          </ul>
          <p>
            (3) Übliche, dem Alter und der Laufleistung entsprechende <strong>Gebrauchsspuren und Verschleißerscheinungen</strong>
            (z. B. Bremsbeläge, Bremsscheiben, Reifen, Wischerblätter, Zündkerzen, Filter, Batterie, Lackzustand
            entsprechend Baujahr) stellen keinen Mangel im Sinne der Gewährleistung dar.
          </p>
          <p>
            (4) Bekannte Mängel werden im Kaufvertrag bzw. Übergabeprotokoll dokumentiert und sind von der
            Gewährleistung ausgenommen, soweit der Käufer ihnen zustimmt.
          </p>
          <p>
            (5) Im Gewährleistungsfall hat der Käufer primär Anspruch auf Verbesserung (Reparatur) oder
            Austausch. Erst wenn beide Abhilfearten unmöglich, unverhältnismäßig oder gescheitert sind,
            kann der Käufer Preisminderung oder — bei nicht geringfügigen Mängeln — Vertragsauflösung
            (Wandlung) verlangen.
          </p>
        </Section>

        <Section title="§ 6 Rücktrittsrechte des Verbrauchers (KSchG, FAGG)">
          <p>
            (1) Bei Vertragsabschluss in den Geschäftsräumen des Verkäufers (4840 Vöcklabruck) bestehen
            <strong> kein gesetzliches Rücktrittsrecht</strong> nach FAGG und keine Cooling-Off-Periode.
          </p>
          <p>
            (2) Bei Vertragsabschluss im Fernabsatz (z. B. rein telefonisch, schriftlich oder elektronisch
            ohne persönlichen Kontakt) steht dem Verbraucher ein 14-tägiges Rücktrittsrecht gemäß § 11 FAGG zu,
            wobei der Verkäufer den Käufer hierüber gesondert informiert und das Muster-Widerrufsformular
            zur Verfügung stellt.
          </p>
          <p>
            (3) Bei <strong>Anbahnung außerhalb der Geschäftsräume</strong> (z. B. Hausbesuch beim Käufer)
            besteht das Rücktrittsrecht gemäß § 3 KSchG.
          </p>
        </Section>

        <Section title="§ 7 Haftung">
          <p>
            (1) Für Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit sowie für sonstige
            Schäden aufgrund vorsätzlichen oder grob fahrlässigen Verhaltens haftet der Verkäufer unbeschränkt.
          </p>
          <p>
            (2) Im Übrigen ist die Haftung für leichte Fahrlässigkeit auf den Ersatz typischer und vorhersehbarer
            Schäden begrenzt, soweit gesetzlich zulässig.
          </p>
          <p>
            (3) Die Haftung für mittelbare Schäden, entgangenen Gewinn, Folgeschäden und reine Vermögensschäden
            ist ausgeschlossen, soweit dies gesetzlich zulässig ist.
          </p>
          <p>
            (4) Eine Beschränkung der Haftung nach Produkthaftungsgesetz (PHG) bleibt unberührt.
          </p>
        </Section>

        <Section title="§ 8 Probefahrten">
          <p>
            (1) Probefahrten sind nach Terminvereinbarung und nur in Begleitung des Verkäufers oder einer
            von ihm bevollmächtigten Person möglich.
          </p>
          <p>
            (2) Der Käufer hat einen gültigen Führerschein der entsprechenden Klasse sowie einen amtlichen
            Lichtbildausweis vorzulegen. Eine Kopie kann zur Aktenführung angefertigt werden.
          </p>
          <p>
            (3) Während der Probefahrt haftet der Käufer für selbstverschuldete Schäden am Fahrzeug nach den
            allgemeinen zivilrechtlichen Vorschriften. Vorhandener Versicherungsschutz und Selbstbehalt werden
            vor Antritt der Fahrt schriftlich erläutert.
          </p>
        </Section>

        <Section title="§ 9 Höhere Gewalt">
          <p>
            Ereignisse höherer Gewalt (z. B. Naturkatastrophen, Pandemien, behördliche Maßnahmen, Streiks bei
            wesentlichen Zulieferern) entbinden die Parteien für die Dauer ihrer Auswirkungen von der Verpflichtung
            zur rechtzeitigen Leistung. Schadenersatzansprüche sind in diesen Fällen ausgeschlossen.
          </p>
        </Section>

        <Section title="§ 10 Datenschutz">
          <p>
            Die Verarbeitung personenbezogener Daten erfolgt ausschließlich nach den Bestimmungen der
            DSGVO und des österreichischen DSG. Details siehe{" "}
            <Link to="/datenschutz" className="underline text-slate-900">Datenschutzerklärung</Link>.
          </p>
        </Section>

        <Section title="§ 11 Online-Streitbeilegung">
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung bereit:{" "}
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="underline text-slate-900">ec.europa.eu/consumers/odr</a>.
            Der Verkäufer ist weder verpflichtet noch bereit, an einem Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>
        </Section>

        <Section title="§ 12 Schlussbestimmungen">
          <p>
            (1) Es gilt ausschließlich österreichisches Recht unter Ausschluss des UN-Kaufrechts (CISG) und
            der Verweisungsnormen des internationalen Privatrechts.
          </p>
          <p>
            (2) Gerichtsstand für Streitigkeiten mit Unternehmern ist das sachlich zuständige Gericht in
            Vöcklabruck. Für Verbraucher gilt der gesetzliche Gerichtsstand gemäß § 14 KSchG.
          </p>
          <p>
            (3) <strong>Salvatorische Klausel:</strong> Sollten einzelne Bestimmungen dieser AGB unwirksam,
            nichtig oder undurchführbar sein oder werden, bleibt die Wirksamkeit der übrigen Bestimmungen
            davon unberührt. An die Stelle der unwirksamen Bestimmung tritt jene wirksame Regelung, die dem
            wirtschaftlichen Zweck der unwirksamen am nächsten kommt.
          </p>
          <p>
            (4) Änderungen und Ergänzungen dieser AGB sowie Nebenabreden bedürfen zu ihrer Wirksamkeit der
            Schriftform. Dies gilt auch für ein Abgehen von diesem Schriftformerfordernis.
          </p>
        </Section>

        <div className="pt-6 border-t border-slate-200 text-xs text-slate-500">
          Weiterführende Informationen finden Sie in unserer{" "}
          <Link to="/datenschutz" className="underline text-slate-900">Datenschutzerklärung</Link> und im{" "}
          <Link to="/impressum" className="underline text-slate-900">Impressum</Link>.
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading font-semibold text-lg text-slate-900 mb-3">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
